import React from 'react';

import './App.css';
import Submission from "./Submission";
import AppTopbar from "./AppTopbar";
import AppFooter from "./AppFooter";

function App() {


    return (
        <div className={'layout-wrapper'}>
            <header>
                <AppTopbar/>
            </header>
            <main className="layout-main">
                <Submission/>
            </main>
            <footer>
                <AppFooter/>
            </footer>
        </div>

    );
}

export default App;
